import { Injectable } from '@angular/core';

// Interfaces
import { Country } from '../interfaces/country.interface';

@Injectable()
export class CountryService {

  // Countries
  public countries: Country[];

  // Constructor
  constructor() {
    const countries = [
      {
        dial_code: 358,
        country_code: 'ax'
      },
      {
        dial_code: 93,
        country_code: 'af'
      },
      {
        dial_code: 355,
        country_code: 'al'
      },
      {
        dial_code: 213,
        country_code: 'dz'
      },
      {
        dial_code: 376,
        country_code: 'ad'
      },
      {
        dial_code: 244,
        country_code: 'ao'
      },
      {
        dial_code: 54,
        country_code: 'ar'
      },
      {
        dial_code: 374,
        country_code: 'am'
      },
      {
        dial_code: 297,
        country_code: 'aw'
      },
      {
        dial_code: 61,
        country_code: 'au'
      },
      {
        dial_code: 43,
        country_code: 'at'
      },
      {
        dial_code: 994,
        country_code: 'az'
      },
      {
        dial_code: 1242,
        country_code: 'bs'
      },
      {
        dial_code: 973,
        country_code: 'bh'
      },
      {
        dial_code: 880,
        country_code: 'bd'
      },
      {
        dial_code: 1246,
        country_code: 'bb'
      },
      {
        dial_code: 375,
        country_code: 'by'
      },
      {
        dial_code: 32,
        country_code: 'be'
      },
      {
        dial_code: 501,
        country_code: 'bz'
      },
      {
        dial_code: 229,
        country_code: 'bj'
      },
      {
        dial_code: 1441,
        country_code: 'bm'
      },
      {
        dial_code: 975,
        country_code: 'bt'
      },
      {
        dial_code: 591,
        country_code: 'bo'
      },
      {
        dial_code: 387,
        country_code: 'ba'
      },
      {
        dial_code: 267,
        country_code: 'bw'
      },
      {
        dial_code: 55,
        country_code: 'br'
      },
      {
        dial_code: 246,
        country_code: 'io'
      },
      {
        dial_code: 1284,
        country_code: 'vg'
      },
      {
        dial_code: 673,
        country_code: 'bn'
      },
      {
        dial_code: 359,
        country_code: 'bg'
      },
      {
        dial_code: 226,
        country_code: 'bf'
      },
      {
        dial_code: 257,
        country_code: 'bi'
      },
      {
        dial_code: 855,
        country_code: 'kh'
      },
      {
        dial_code: 237,
        country_code: 'cm'
      },
      {
        dial_code: 1,
        country_code: 'ca'
      },
      {
        dial_code: 238,
        country_code: 'cv'
      },
      {
        dial_code: 599,
        country_code: 'bq'
      },
      {
        dial_code: 1345,
        country_code: 'ky'
      },
      {
        dial_code: 236,
        country_code: 'cf'
      },
      {
        dial_code: 235,
        country_code: 'td'
      },
      {
        dial_code: 56,
        country_code: 'cl'
      },
      {
        dial_code: 86,
        country_code: 'cn'
      },
      {
        dial_code: 61,
        country_code: 'cx'
      },
      {
        dial_code: 57,
        country_code: 'co'
      },
      {
        dial_code: 269,
        country_code: 'km'
      },
      {
        dial_code: 243,
        country_code: 'cd'
      },
      {
        dial_code: 242,
        country_code: 'cg'
      },
      {
        dial_code: 682,
        country_code: 'ck'
      },
      {
        dial_code: 506,
        country_code: 'cr'
      },
      {
        dial_code: 225,
        country_code: 'ci'
      },
      {
        dial_code: 385,
        country_code: 'hr'
      },
      {
        dial_code: 53,
        country_code: 'cu'
      },
      {
        dial_code: 599,
        country_code: 'cw'
      },
      {
        dial_code: 357,
        country_code: 'cy'
      },
      {
        dial_code: 420,
        country_code: 'cz'
      },
      {
        dial_code: 45,
        country_code: 'dk'
      },
      {
        dial_code: 253,
        country_code: 'dj'
      },
      {
        dial_code: 1767,
        country_code: 'dm'
      },
      {
        dial_code: 1,
        country_code: 'do'
      },
      {
        dial_code: 593,
        country_code: 'ec'
      },
      {
        dial_code: 20,
        country_code: 'eg'
      },
      {
        dial_code: 503,
        country_code: 'sv'
      },
      {
        dial_code: 240,
        country_code: 'gq'
      },
      {
        dial_code: 291,
        country_code: 'er'
      },
      {
        dial_code: 372,
        country_code: 'ee'
      },
      {
        dial_code: 251,
        country_code: 'et'
      },
      {
        dial_code: 500,
        country_code: 'fk'
      },
      {
        dial_code: 298,
        country_code: 'fo'
      },
      {
        dial_code: 679,
        country_code: 'fj'
      },
      {
        dial_code: 358,
        country_code: 'fi'
      },
      {
        dial_code: 33,
        country_code: 'fr'
      },
      {
        dial_code: 594,
        country_code: 'gf'
      },
      {
        dial_code: 689,
        country_code: 'pf'
      },
      {
        dial_code: 241,
        country_code: 'ga'
      },
      {
        dial_code: 220,
        country_code: 'gm'
      },
      {
        dial_code: 995,
        country_code: 'ge'
      },
      {
        dial_code: 49,
        country_code: 'de'
      },
      {
        dial_code: 233,
        country_code: 'gh'
      },
      {
        dial_code: 350,
        country_code: 'gi'
      },
      {
        dial_code: 30,
        country_code: 'gr'
      },
      {
        dial_code: 299,
        country_code: 'gl'
      },
      {
        dial_code: 1473,
        country_code: 'gd'
      },
      {
        dial_code: 590,
        country_code: 'gp'
      },
      {
        dial_code: 1671,
        country_code: 'gu'
      },
      {
        dial_code: 502,
        country_code: 'gt'
      },
      {
        dial_code: 44,
        country_code: 'gg'
      },
      {
        dial_code: 224,
        country_code: 'gn'
      },
      {
        dial_code: 245,
        country_code: 'gw'
      },
      {
        dial_code: 592,
        country_code: 'gy'
      },
      {
        dial_code: 509,
        country_code: 'ht'
      },
      {
        dial_code: 504,
        country_code: 'hn'
      },
      {
        dial_code: 852,
        country_code: 'hk'
      },
      {
        dial_code: 36,
        country_code: 'hu'
      },
      {
        dial_code: 354,
        country_code: 'is'
      },
      {
        dial_code: 91,
        country_code: 'in'
      },
      {
        dial_code: 62,
        country_code: 'id'
      },
      {
        dial_code: 98,
        country_code: 'ir'
      },
      {
        dial_code: 964,
        country_code: 'iq'
      },
      {
        dial_code: 353,
        country_code: 'ie'
      },
      {
        dial_code: 44,
        country_code: 'im'
      },
      {
        dial_code: 972,
        country_code: 'il'
      },
      {
        dial_code: 39,
        country_code: 'it'
      },
      {
        dial_code: 1876,
        country_code: 'jm'
      },
      {
        dial_code: 81,
        country_code: 'jp'
      },
      {
        dial_code: 44,
        country_code: 'je'
      },
      {
        dial_code: 962,
        country_code: 'jo'
      },
      {
        dial_code: 7,
        country_code: 'kz'
      },
      {
        dial_code: 254,
        country_code: 'ke'
      },
      {
        dial_code: 686,
        country_code: 'ki'
      },
      {
        dial_code: 383,
        country_code: 'xk'
      },
      {
        dial_code: 965,
        country_code: 'kw'
      },
      {
        dial_code: 996,
        country_code: 'kg'
      },
      {
        dial_code: 856,
        country_code: 'la'
      },
      {
        dial_code: 371,
        country_code: 'lv'
      },
      {
        dial_code: 961,
        country_code: 'lb'
      },
      {
        dial_code: 266,
        country_code: 'ls'
      },
      {
        dial_code: 231,
        country_code: 'lr'
      },
      {
        dial_code: 218,
        country_code: 'ly'
      },
      {
        dial_code: 423,
        country_code: 'li'
      },
      {
        dial_code: 370,
        country_code: 'lt'
      },
      {
        dial_code: 352,
        country_code: 'lu'
      },
      {
        dial_code: 853,
        country_code: 'mo'
      },
      {
        dial_code: 389,
        country_code: 'mk'
      },
      {
        dial_code: 261,
        country_code: 'mg'
      },
      {
        dial_code: 265,
        country_code: 'mw'
      },
      {
        dial_code: 60,
        country_code: 'my'
      },
      {
        dial_code: 960,
        country_code: 'mv'
      },
      {
        dial_code: 223,
        country_code: 'ml'
      },
      {
        dial_code: 356,
        country_code: 'mt'
      },
      {
        dial_code: 692,
        country_code: 'mh'
      },
      {
        dial_code: 596,
        country_code: 'mq'
      },
      {
        dial_code: 222,
        country_code: 'mr'
      },
      {
        dial_code: 230,
        country_code: 'mu'
      },
      {
        dial_code: 262,
        country_code: 'yt'
      },
      {
        dial_code: 52,
        country_code: 'mx'
      },
      {
        dial_code: 691,
        country_code: 'fm'
      },
      {
        dial_code: 373,
        country_code: 'md'
      },
      {
        dial_code: 377,
        country_code: 'mc'
      },
      {
        dial_code: 976,
        country_code: 'mn'
      },
      {
        dial_code: 382,
        country_code: 'me'
      },
      {
        dial_code: 1664,
        country_code: 'ms'
      },
      {
        dial_code: 212,
        country_code: 'ma'
      },
      {
        dial_code: 258,
        country_code: 'mz'
      },
      {
        dial_code: 95,
        country_code: 'mm'
      },
      {
        dial_code: 264,
        country_code: 'na'
      },
      {
        dial_code: 674,
        country_code: 'nr'
      },
      {
        dial_code: 977,
        country_code: 'np'
      },
      {
        dial_code: 31,
        country_code: 'nl'
      },
      {
        dial_code: 687,
        country_code: 'nc'
      },
      {
        dial_code: 64,
        country_code: 'nz'
      },
      {
        dial_code: 505,
        country_code: 'ni'
      },
      {
        dial_code: 227,
        country_code: 'ne'
      },
      {
        dial_code: 234,
        country_code: 'ng'
      },
      {
        dial_code: 683,
        country_code: 'nu'
      },
      {
        dial_code: 672,
        country_code: 'nf'
      },
      {
        dial_code: 850,
        country_code: 'kp'
      },
      {
        dial_code: 1670,
        country_code: 'mp'
      },
      {
        dial_code: 47,
        country_code: 'no'
      },
      {
        dial_code: 968,
        country_code: 'om'
      },
      {
        dial_code: 92,
        country_code: 'pk'
      },
      {
        dial_code: 680,
        country_code: 'pw'
      },
      {
        dial_code: 970,
        country_code: 'ps'
      },
      {
        dial_code: 507,
        country_code: 'pa'
      },
      {
        dial_code: 675,
        country_code: 'pg'
      },
      {
        dial_code: 595,
        country_code: 'py'
      },
      {
        dial_code: 51,
        country_code: 'pe'
      },
      {
        dial_code: 63,
        country_code: 'ph'
      },
      {
        dial_code: 48,
        country_code: 'pl'
      },
      {
        dial_code: 351,
        country_code: 'pt'
      },
      {
        dial_code: 1,
        country_code: 'pr'
      },
      {
        dial_code: 974,
        country_code: 'qa'
      },
      {
        dial_code: 262,
        country_code: 're'
      },
      {
        dial_code: 40,
        country_code: 'ro'
      },
      {
        dial_code: 7,
        country_code: 'ru'
      },
      {
        dial_code: 250,
        country_code: 'rw'
      },
      {
        dial_code: 590,
        country_code: 'bl'
      },
      {
        dial_code: 290,
        country_code: 'sh'
      },
      {
        dial_code: 1869,
        country_code: 'kn'
      },
      {
        dial_code: 1758,
        country_code: 'lc'
      },
      {
        dial_code: 508,
        country_code: 'pm'
      },
      {
        dial_code: 1784,
        country_code: 'vc'
      },
      {
        dial_code: 685,
        country_code: 'ws'
      },
      {
        dial_code: 378,
        country_code: 'sm'
      },
      {
        dial_code: 239,
        country_code: 'st'
      },
      {
        dial_code: 966,
        country_code: 'sa'
      },
      {
        dial_code: 221,
        country_code: 'sn'
      },
      {
        dial_code: 381,
        country_code: 'rs'
      },
      {
        dial_code: 248,
        country_code: 'sc'
      },
      {
        dial_code: 232,
        country_code: 'sl'
      },
      {
        dial_code: 65,
        country_code: 'sg'
      },
      {
        dial_code: 1721,
        country_code: 'sx'
      },
      {
        dial_code: 421,
        country_code: 'sk'
      },
      {
        dial_code: 386,
        country_code: 'si'
      },
      {
        dial_code: 677,
        country_code: 'sb'
      },
      {
        dial_code: 252,
        country_code: 'so'
      },
      {
        dial_code: 27,
        country_code: 'za'
      },
      {
        dial_code: 82,
        country_code: 'kr'
      },
      {
        dial_code: 211,
        country_code: 'ss'
      },
      {
        dial_code: 34,
        country_code: 'es'
      },
      {
        dial_code: 94,
        country_code: 'lk'
      },
      {
        dial_code: 249,
        country_code: 'sd'
      },
      {
        dial_code: 597,
        country_code: 'sr'
      },
      {
        dial_code: 47,
        country_code: 'sj'
      },
      {
        dial_code: 268,
        country_code: 'sz'
      },
      {
        dial_code: 46,
        country_code: 'se'
      },
      {
        dial_code: 41,
        country_code: 'ch'
      },
      {
        dial_code: 963,
        country_code: 'sy'
      },
      {
        dial_code: 886,
        country_code: 'tw'
      },
      {
        dial_code: 992,
        country_code: 'tj'
      },
      {
        dial_code: 255,
        country_code: 'tz'
      },
      {
        dial_code: 66,
        country_code: 'th'
      },
      {
        dial_code: 670,
        country_code: 'tl'
      },
      {
        dial_code: 228,
        country_code: 'tg'
      },
      {
        dial_code: 690,
        country_code: 'tk'
      },
      {
        dial_code: 676,
        country_code: 'to'
      },
      {
        dial_code: 1868,
        country_code: 'tt'
      },
      {
        dial_code: 216,
        country_code: 'tn'
      },
      {
        dial_code: 90,
        country_code: 'tr'
      },
      {
        dial_code: 993,
        country_code: 'tm'
      },
      {
        dial_code: 1649,
        country_code: 'tc'
      },
      {
        dial_code: 688,
        country_code: 'tv'
      },
      {
        dial_code: 1340,
        country_code: 'vi'
      },
      {
        dial_code: 256,
        country_code: 'ug'
      },
      {
        dial_code: 380,
        country_code: 'ua'
      },
      {
        dial_code: 971,
        country_code: 'ae'
      },
      {
        dial_code: 44,
        country_code: 'gb'
      },
      {
        dial_code: 1,
        country_code: 'us'
      },
      {
        dial_code: 598,
        country_code: 'uy'
      },
      {
        dial_code: 998,
        country_code: 'uz'
      },
      {
        dial_code: 678,
        country_code: 'vu'
      },
      {
        dial_code: 39,
        country_code: 'va'
      },
      {
        dial_code: 58,
        country_code: 've'
      },
      {
        dial_code: 84,
        country_code: 'vn'
      },
      {
        dial_code: 681,
        country_code: 'wf'
      },
      {
        dial_code: 212,
        country_code: 'eh'
      },
      {
        dial_code: 967,
        country_code: 'ye'
      },
      {
        dial_code: 260,
        country_code: 'zm'
      },
      {
        dial_code: 263,
        country_code: 'zw'
      }
    ];

    this.countries = countries.sort((a, b) => a.dial_code - b.dial_code);
  }

  // Get Countries
  public getCountry(country_code?: string): Country[] | Country {
    if (!country_code) {
      return this.countries;
    } else {
      const i = this.countries.findIndex((item: Country) => item.country_code === country_code);
      return this.countries[i];
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/intl-phone/services/country.service.ts